import { PaginationPcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { Partner, PartnerWithId } from '@/pages/:AUTH_INFO_ID/partner/types/partner';
import { api } from '@/utils/api';

export type SvcListSearchParams = {
  page: number;
} & Partner;

const DEFAULT_PAGE_SIZE = 10;
export const getSvcListSearch = (params: SvcListSearchParams) => {
  return api<PaginationPcApiResponse<PartnerWithId[]>>('get', `/pc-api/v1/${PREFIX_PATH}/svc/list/search`, {
    size: DEFAULT_PAGE_SIZE,
    ...params
  });
};
